import { Group, Project } from "@nova/protobuf"
import {
    createLayerValidator,
    enumValidator,
    genericUpdateLayerValidator,
    nameValidators,
    UnionToTuple,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import { GroupType } from "@nova/constants"

export const createGroupValidator = createLayerValidator(Group, {
    name: { validators: nameValidators, nonNull: true },
    index: { validators: [], nonNull: true },
    parentId: { validators: [] },
    groupType: { validators: enumValidator("groupType", GroupType) },
})

export const updateGroupValidator = genericUpdateLayerValidator

export const getDefaultGroupCreateArgs = (project: Project, inParentId?: string) => {
    return {
        visible: true,
        createdAt: dateAsNumber(),
        index: createNewLayerFractionalIndex(project, 0, inParentId),
        // parentId would never got autopopulated
        parentId: undefined,
    }
}

export type CreateGroupArgs = UnionToTuple<keyof typeof createGroupValidator>
export type UpdateGroupArgs = UnionToTuple<keyof typeof updateGroupValidator>
